<template>
  <div class="ask" :style="{'margin-top':top_margin+45 + 'px'}">
    <van-nav-bar title="问" :border='false' :style="{'margin-top':top_margin + 'px'}">
      <img slot="left" class="navbarmem" @click="goMy(0)" :src="user && user.avatar ? user.avatar : img.avatar">
      <img slot="title" class="navbartitle" :src="img.navask">
      <img slot="right" @click="PopupShow" class="navbarwrite" :src="img.write">
    </van-nav-bar>
    <div class="top">
      <van-tabs color="#3A3A3A" title-active-color="#3A3A3A" v-model="params.type" @click="getName">
        <van-tab title="推荐" name=""></van-tab>
        <van-tab title="买车问题" name="1"></van-tab>
        <van-tab title="用车问题" name="2"></van-tab>
        <van-tab title="故障问题" name="3"></van-tab>
      </van-tabs>
    </div>
    <div class="cenus">
      · {{ total }} 条问题
      <span class="f-r" @click="ShowFilter">{{filterName}}<van-icon name="arrow-down" /></span>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="content">
        <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已加载全部"
        @load="onLoad"
        >
        <div slot="loading" class="list-loading">
          <img :src="img.loading" />
        </div>
        <div class="list-box" v-for="(item,index) in list" :key="'list_' + item.id">
          <div v-if="item.answer">
            <van-row class="conpdd" type="flex" justify="space-between" v-if="item.answer.user">
              <van-col span="4">                  
                <img @click="goMy(1,item.answer.user.id)" class="listhand" :src="item.answer.user.headimg_url&&item.answer.user.headimg_url.substring(0,5)=='https' ? item.answer.user.headimg_url : img.avatar">
              </van-col>
              <van-col @click="goMy(1,item.answer.user.id)" span="15">
                <div v-if="item.answer.user.intro" class="membername">
                  {{item.answer.user.user_name}}
                </div>
                <div v-if="item.answer.user.intro" class="sourtime">
                  {{item.answer.user.intro}}
                </div>
                <div v-else class="activename">
                  {{item.answer.user.user_name}}
                </div>
              </van-col>
              <van-col class="bintright" span="5">
                <van-button class="follow" v-if="item.answer.user.is_follow==0" icon="plus" color="#5F5B6B" size="small" @click="follow(index)" :data-code="item.answer.user.id">关 注</van-button>
              </van-col>
            </van-row>
            <div class="listitle ellipsis-2 conpdd" @click="LexusAskShow(0,item.answer.id)">{{ item.question }}</div>
            <div class="f-15 ellipsis-4 conpdd" @click="LexusAskShow(0,item.answer.id)">
              <img class="answtag" :src="img.answericon">
              <span class="titleqa linheight">{{ item.answer.content.text }}</span>
            </div>
            <div class="pic-box" v-if="item.answer.content.img">
              <img class="pic_thumb" v-lazy="item.answer.content.img" @click="showImg(item.answer.content.img)">
            </div>
            <van-row class="conpdd" type="flex" justify="space-between">
              <van-col span="18">
                <span class="binbox">
                  <img @click="setPraise(index)" class="binpic" :src="item.answer.is_praise ? img.collect_have : img.collect">
                  <span class="sournum" v-if="item.answer.praise_num > 0">{{item.answer.praise_num}}</span>
                </span>
                <span class="binbox" @click="LexusAskShow(0,item.answer.id)">
                  <img class="binpic" :src="img.comment">
                  <span class="sournum"></span>
                </span>
                <span class="binbox" hidden="true">
                  <img class="binpic" :src="img.inrelay">
                  <span class="sournum"></span>
                </span>
              </van-col>
              <van-col class="bintright" span="6" @click="outrelay(item.question,item.answer.content.text,'/lexus/ask/'+item.answer.id+'/answer',item.answer.content.img)">
                <img class="binpic" :src="img.outrelay">
              </van-col>
            </van-row>
            <div class="quetype conpdd">{{item.labels[0].name}} · {{item.answer.answer_time}}</div>
          </div>
          <div v-else>
            <div class="listitle listitle2 ellipsis-2" @click="LexusAskShow(1,item.id)">
              <!-- <router-link :to="{name: 'LexusAskShow', params: {id: item.id}}" class="c-black"> -->
                <img class="answtag" :src="img.questionicon">
                <span class="titleqa">{{ item.question }}</span>
                <!-- </router-link> -->
              </div>
              <div class="f-15 ellipsis-4 conpdd" @click="LexusAskShow(1,item.id)">
                <!-- <router-link :to="{name: 'LexusAskShow', params: {id: item.id}}" class="c-black linheight"> -->
                  {{ item.content }}
                  <!-- </router-link> -->
                </div>
                <div class="pic-box" v-if="item.image">
                  <img class="pic_thumb" v-lazy="item.image[0]" @click="showImg(item.image[0])">
                </div>
                <van-row class="conpdd" type="flex" justify="space-between">
                  <van-col span="14">
                    <span class="sourtime">
                      <span v-if="item.answer_num > 0">{{ item.answer_num + '个回答' }} </span>
                      <span v-if="item.collect_num > 0">{{ item.collect_num + '个收藏' }}</span>
                    </span>
                  </van-col>
                  <van-col class="bintright" span="10">
                    <span class="sourtime" @click="goPost(5,item.question,item.id)">
                      <span class="c-blue f-14">我要回答</span>
                    </span>
                  </van-col>
                </van-row>
              </div>
            </div>
          </van-list>
        </div>
      </van-pull-refresh>
      <van-popup class="post" v-model="show" @close="close()"
      :style="{ top: '13%',width:'30%','text-align':'center','left':'82%' }">
      <div class="triangle"></div>
      <div class="popback">
        <van-cell title="写动态" @click="goPost(1)" :icon="img.dynamic" />
          <!-- <van-cell title="图片" @click="goPost(2)" :icon="img.pictur" />
            <van-cell title="视频" @click="goPost(3)" :icon="img.video" /> -->
            <van-cell title="提问" @click="goPost(4)" :icon="img.ask" />
          </div>
        </van-popup>
        <van-popup v-model="showFilter" 
        :style="{ top: '30%',width:'30%',left:'80%','text-align':'left','margin-right':'15px','border-radius':'5px','font-size':'13px','color':'#3A3A3A' }">
        <van-cell class="popupcolor" title="看全部" data-code='0' @click="CheckFilter">
          <van-icon v-if="params.filter==0"
          slot="right-icon"
          name="success"
          style="line-height: inherit;"
          />
        </van-cell>
        <van-cell class="popupcolor" title="只看答案" data-code='1' @click="CheckFilter">
          <van-icon v-if="params.filter==1"
          slot="right-icon"
          name="success"
          style="line-height: inherit;"
          />
        </van-cell>
        <van-cell class="popupcolor" title="只看问题" data-code='2' @click="CheckFilter">
          <van-icon v-if="params.filter==2"
          slot="right-icon"
          name="success"
          style="line-height: inherit;"
          />
        </van-cell> 
      </van-popup>
      <van-image-preview
      v-model="showState"
      :images="images"
      lazyLoad
      @close="close"
      >
    </van-image-preview>
    <van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @click-overlay="onCancel" @cancel="onCancel">
      <van-divider class="divider">分享</van-divider>
      <van-grid :border='false' :column-num="5">
        <!-- <van-grid-item :icon="img.inrelay" /> -->
        <van-grid-item :icon="img.friends" @click="toShare(2)" />
        <van-grid-item :icon="img.wechat" @click="toShare(1)" />
      <!-- <van-grid-item :icon="img.link" />
        <van-grid-item :icon="img.poster" /> -->
      </van-grid>
    </van-action-sheet>
    <div class="totopbox" @click="toTop" v-if="scroll">
      <img class="totop" :src="img.totop">
    </div>
  </div> 
</template>
<script>
  import ask from '../../../api/ask';
  import content from '../../../api/content';
  import member from '../../../api/member/memberinfo';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import {List, Row, Col, Tab, Tabs, Tag, Button,NavBar,Popup,Cell, CellGroup,Icon,Grid, GridItem,ActionSheet,Divider,PullRefresh } from "vant";
  export default {
    data () {
      return {
        params: {
          channel_id:5,
          page: 1,
          size: 4,
          type: 0,
          filter: 0,
          user_id: 0
        },
        total: 0,
        topics: [],
        list: [],
        loading: false,
        finished: false,
        isLoading:false,
        show:false,
        showFilter:false,
        filterName:'看全部',
        showState:false,
        images:[],
        shareshow:false,
        top_margin: 0,
        scroll:false,
        img: {
          avatar: require('../../../assets/img/lexus/default.png'),
          collect: require('../../../assets/img/lexus/collect.png'),
          collect_have: require('../../../assets/img/lexus/collect_have.png'),
          comment: require('../../../assets/img/lexus/comment.png'),
          inrelay: require('../../../assets/img/lexus/inrelay.png'),
          outrelay: require('../../../assets/img/lexus/outrelay.png'),
          loading: require('../../../assets/img/loading_lexus.gif'),
          question: require('../../../assets/img/question.png'),
          answer: require('../../../assets/img/answers.png'),
          write: require('../../../assets/img/lexus/write-black.png'),
          navask: require('../../../assets/img/lexus/navask.png'),
          dynamic:require('../../../assets/img/lexus/dynamic.png'),
          pictur:require('../../../assets/img/lexus/pictur.png'),
          video:require('../../../assets/img/lexus/video.png'),
          ask:require('../../../assets/img/lexus/ask.png'),
          answericon: require('../../../assets/img/lexus/answericon.png'),
          questionicon: require('../../../assets/img/lexus/questionicon.png'),
          friends: require('../../../assets/img/lexus/friends.png'),
          wechat: require('../../../assets/img/lexus/wechat.png'),
          link: require('../../../assets/img/lexus/link.png'),
          poster: require('../../../assets/img/lexus/poster.png'),
          totop: require('../../../assets/img/lexus/totop.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.getTopics()
      this.getMyInfo()
      this.weburl=process.env.VUE_APP_URL
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        }
      })
    },
    activated () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: false})
      this.$appService.getWinHeight(v => {
        console.log('getWinHeight=='+v.height)
        this.top_margin = 0
      })
      this.$appService.isTabbar({state: false})
    },
    // mounted () {
    //   window.addEventListener('scroll', this.scrollToTop)
    // },
    methods: {
      setPraise (index) {
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        if(this.user) {
          let type = this.list[index].answer.is_praise ? 2 : 1;
          ask.setPraise({id: this.list[index].answer.id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.list[index].answer.is_praise = 1
                this.list[index].answer.praise_num += 1
              } else {
                this.list[index].answer.is_praise = 0
                this.list[index].answer.praise_num -= 1
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }
      },
      PopupShow(){
        this.show=true
        this.$appService.isTabbar({state: true})
      },
      scrollToTop() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        if(scrollTop>224){
          this.scroll=true
        }else{
          this.scroll=false
        }
      },
      toTop(){
        scrollTo(0,0);
        this.scroll=false
      },
      ShowFilter(){
        this.showFilter=true
      },
      CheckFilter(e){
        this.params.filter=e.currentTarget.dataset.code
        this.filterName=e.currentTarget.innerText
        this.showFilter=false
        this.params.page= 1
        this.list = [];
        this.onLoad()
      },
      getName() {
        this.params.page = 1;
        this.list = [];
        if(this.finished){
          this.finished=false
        }else{
          this.onLoad();
        }
      },
      getTopics() {
        ask.getTopics().then(res => {
          if(res.data.state == 1) {
            this.topics = res.data.data
          }
        })
      },
      follow(index){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        if(this.user) {
          let type = this.list[index].answer.user.is_follow==1 ? 2 : 1;
          content.Follow({follow_user_id: this.list[index].answer.user.id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.list[index].answer.user.is_follow=1
                var id=this.list[index].answer.user.id
                var list=this.list
                for(var i=0;i<list.length;i++){
                  if(list[i].answer.user.id==id){
                    var followi=this.list[i].answer.user.is_follow
                    this.list[i].answer.user.is_follow=1
                  }
                }
              } else {
                this.list[index].answer.user.is_follow=0
                var id=this.list[index].answer.user.id
                var list=this.list
                for(var i=0;i<list.length;i++){
                  if(list[i].answer.user.id==id){
                    var followi=this.list[i].answer.user.is_follow
                    this.list[i].answer.user.is_follow=0
                  }
                }
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }
      },
      showImg(image){
        this.$appService.isTabbar({state: true})
        var images=[]
        images.push(image)
        this.images=images
        this.showState=true
      },
      close(){
        this.show=false
        this.$appService.isTabbar({state: false})
      },
      goPost(type,title,id){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
            var params={
              qid:id,
              type:type,
              title:title
            }
            this.show=false
            this.$appService.goPost(params)
          } else {
            var params={
              pagetype:1,
              type:type
            }
            this.$appService.needLogin(params)
          }
        })
      },
      goMy(type,id){
        var params={
          url:'' ,
          isReturn: true 
        }
        if(type==0){
          params.url=this.weburl+'/lexus/my?source='+this.source
        }else{
          params.url=this.weburl+'/lexus/my/other/'+id+'?source='+this.source
        }
        this.$appService.openWebView(params)
      },
      LexusAskShow(type,id){
        var params={
          url:'' ,
          isReturn: true 
        }
        if(type==0){
          params.url=this.weburl+'/lexus/ask/'+id+'/answer'+'?source='+this.source
        }else{
         params.url=this.weburl+'/lexus/ask/'+id+'?source='+this.source
       }
       this.$appService.openWebView(params)
     },
     outrelay(title,content,url,imageUrl){
      this.$appService.isTabbar({state: true})
      this.shareshow=true
      this.sharetitle=title
      this.sharecontent=content
      this.shareurl=this.weburl+url+'?source='+this.source
      if(imageUrl){
        this.shareimageUrl=imageUrl
      }else{
        this.shareimageUrl='https://pic.motortime.com/logo/lexus_logo.png'
      }
    },
    toShare(type){
      var params={
        type:type,
        title:this.sharetitle,
        content:this.sharecontent,
        url:this.shareurl,
        imageUrl:this.shareimageUrl
      }
      this.shareshow=false
      this.$appService.isTabbar({state: false})
      this.$appService.shareContent(params)
    },
    onCancel(){
      this.$appService.isTabbar({state: false})
    },
    onRefresh() {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        }
      })
      this.isLoading = false;
      this.getMyInfo()
    },
    getMyInfo(){
     var luser=JSON.parse(localStorage.getItem("user"))
     if(luser){
        var id=luser.data.id
        member.getMyInfo(id).then(res => {
          if(res.data.state==1){
            var info=res.data.data
            this.user.avatar=info.avatar
            var params={
              event_code: '问答',
              event_id: '',
              title: '',
              value: '',
              path: '/Lexus/Ask/AskIndex.vue',
              user_id: this.user.id,
              source: this.source
            }
            common.BurialPoint(params).then(res => {
              if(res.data.state==1){
                
              }
            })
          }else{
            var params={
              event_code: '问答',
              event_id: '',
              title: '',
              value: '',
              path: '/Lexus/Ask/AskIndex.vue',
              user_id: this.user.id,
              source: this.source
            }
            common.BurialPoint(params).then(res => {
              if(res.data.state==1){
                
              }
            })
          }
        })
      }
   },
   onLoad() {
    this.params.user_id = this.user ? this.user.id : 0
        // 异步更新数据
        setTimeout(() => {
          ask.getList(this.params).then(res => {
            this.list.push.apply(this.list, res.data.data.data)
            this.params.page += 1
            this.total = res.data.data.total
            this.loading = false

            if(res.data.data.data.length == 0) {
              this.finished = true
            }
          })
        }, 500);
      }
    },
    components: {
      [Row.name]: Row,
      [Col.name]: Col,
      [List.name]: List,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Tag.name]: Tag,
      [Button.name]: Button,
      [Popup.name]: Popup,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Icon.name]: Icon,
      [NavBar.name]:NavBar,
      [ActionSheet.name]:ActionSheet,
      [Divider.name]:Divider,
      [Grid.name]: Grid,
      [GridItem.name]: GridItem,
      [PullRefresh.name]:PullRefresh
    }
  };
</script> 

<style lang="scss">
.ask {
  // margin: 68px 0;
  background-color: #F0F0F0;
  
  .van-nav-bar{
    z-index: 999;
    position: fixed;
    top: 0;
    width: 100%;
    .van-nav-bar__left{
      top: 10px;
      .navbarmem{
        width:30px;
        height:30px;
        object-fit: cover;
      }
    }
    .van-nav-bar__title{
      .navbartitle{
        margin-top: 10px;
        width: 30px;
        height: 27px;
      }
    }
    .van-nav-bar__right{
      top: 5px;
      .navbarwrite{
        width: 20px;
      }
    }
  }
  .top {
    background-color: #FFF;
    padding: 0 10px;
    .van-tab span {
      font-size: 15px;
      font-weight: bold;
    }
    .van-tabs__line{
      z-index: 0;
    }
  }
  .cenus {
    padding: 0 10px;
    background-color: #F0F0F0;
    color: #9A9A9A;
    font-size: 12px;
    line-height: 40px;
    span{
      letter-spacing: 2px;
      .van-icon{
        margin-left: 2px;
      }
    }
  }
  .content {
    background-color: #FFF;

    .list-box {
      padding: 15px 0;
      border-bottom: 1px solid #EAEAEA;

      .quespic{
        width: 22px;
        height: 22px;
        vertical-align: middle;
      }
      .picone{
        width:100%;
        height:105px;
        border-radius:5px;
        object-fit: cover;
      }
      .listitle{
        padding: 0 15px;
        font-size: 15px;
        font-weight:bold;
        line-height: 20px;
        letter-spacing: 1.4px;
        margin: 10px 0;

        &.listitle2 {
          margin-top: 0;
        }
        .titleqa{
          vertical-align: middle;
        }
      }
      .conpdd{
        padding: 0 15px;
      }
      .quetype{
        font-size: 12px;
        color: #6A6A6A;
        margin-top: 10px;
      }
      .sourtime{
        font-size: 12px;
        color: #9A9A9A;
        .c-blue {
          font-size: 12px;
          color: #728FC4;
          background: #F2F6FA url(../../../assets/img/lexus/listask.png) no-repeat 8px center;
          background-size: 13px auto;
          width: 80px;
          height: 25px;
          line-height: 25px;
          display: inline-block;
          text-align: left;
          padding-left: 25px;
          border-radius: 1px;
          box-sizing: border-box;
        }
      }
      .binpic{
        width:15px;
        height:15px;
        margin-right:8px;
        vertical-align: middle;
      }
      .binbox{
        margin-right:20px;
        .sournum{
          font-size: 13px;
          font-weight: bold;
          color: #605C6B;
        }
      }
      .bintright{
        text-align:right;
        .van-button__icon{
          font-size: 12px;
        }
        .van-button__text{
          font-size: 12px;
        }
      }
      .pic-box {
        margin: 10px 0;
        .pic_thumb {
          width: 100%;
          height: 250px;
          object-fit: cover;
          display: block;
        }
      }
      .listhand{
        width:40px;
        height:40px;
        border-radius:1.5px;
      }
      .membername{
        font-size: 13px;
        font-weight: bold;
        line-height: 3;
        color: #605C6B;
      }
      .activename{
        font-size: 13px;
        font-weight: bold;
        line-height: 3;
        color: #605C6B;
      }
      
      
    }
  }
  .post{
    background-color: transparent;
    .van-cell{
      background-color: #5F5B6B;
      color: #fff;
    }
    .popback{
      background-color: #5F5B6B;
      margin-top: 10px;
      .van-cell:not(:last-child)::after{
        right: 10px;
      }
    }
    .triangle{
      width:0;
      height:0;
      border-right:10px solid transparent;
      border-left:10px solid transparent;
      border-bottom:10px solid #5F5B6B;
      float: right;
      margin-right: 5px;
    }
  }
  .answtag{
    width: 15px;
    height: 15px;
    margin-right: 10px;
    vertical-align: middle;
  }
  .linheight{
    line-height: 22px;
    vertical-align: middle;
  }
  .follow{
    vertical-align: super;
  }
  .van-overlay{
    z-index: 999;
  }
  .van-popup{
    .van-cell:not(:last-child)::after{
      border-bottom:0 solid #ebedf0;
    }
    .van-action-sheet__cancel::before{
      height: 1px;
    }
    .divider{
      margin: 20px 80px;
    }
    .van-grid{
      padding: 10px 0;
    }
  }
  .popupcolor{
    color: #3A3A3A;
  }
}
</style>
